import React, { useMemo } from "react";
// import styles1 from "@/styles/components/partnerSubmissionFeeModal.module.scss"
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
// import styles from "@/styles/components/AnalyticPageBreakdownTable/analyticPageBreakdownTable.module.scss"
import styles from "../../styles/components/AnalyticPageBreakdownTable/analyticPageBreakdownTable.module.scss";

import { Button } from "@imarabinda/antd";
import {
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { useQuery } from "react-query";
import { expensesBreakdownList } from "../../api/functions/user.api";
import assest from "../../json/assest";
import CustomSelectTwo from "../CustomSelectTwo/CustomSelectTwo";
import dayjs from "dayjs";
import ApiLoader from "../Loaders/ApiLoader";
// import Image from 'next/image'

function createData(Month, Amount) {
  return { Month, Amount };
}

const AnalyticPageBreakdownTable = ({
  handleOpenExpensesModal,
  selectedYearMonth,
}) => {
  const [status, setStatus] = React.useState(`${new Date().getFullYear()}`);
  // selectedYearMonth.current = {
  //   ...selectedYearMonth.current,
  //   year: `${new Date().getFullYear()}`,
  // };
  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };

  const { data: listdata, isLoading } = useQuery(
    ["EXPENSE_BREAKDOWN", status],
    (body) => expensesBreakdownList(body, { year: status }),
    {
      select: (data) =>
        data && data.length > 0
          ? data.map((_d, idx) => {
              return { ..._d, month_no: idx + 1 };
            })
          : [],
    }
  );
  const midpoint = useMemo(
    () =>
      listdata && listdata?.length > 0 ? Math.ceil(listdata.length / 2) : 0,
    [listdata]
  );
  const yearList = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startingYear = 2021;
    const yearArray = [];

    for (let year = currentYear; year >= startingYear; year--) {
      yearArray.push(year);
    }

    return yearArray;
  }, [new Date().getFullYear(), status]);
  const expenseDetailsHandler = (month, monthName) => {
    selectedYearMonth.current = { year: status, month, monthName };
    handleOpenExpensesModal();
  };
  console.warn("EXPENSE_BREAKDOWN", listdata);
  return (
    <Box className={styles1.analyticsBreakdown}>
      {!isLoading ? (
        <Box
          className={`${styles1.analyticsBreakdownBody} ${styles.analyticsTableBody}`}
        >
          <h4>Expenses breakdown</h4>
          <Box
            className={`${styles1.analysticYearSelect} ${styles.analysticTableYearSelect}`}
          >
            {/* 2021-{dayjs().year()} */}
            {/* {`${yearList}`} */}
            <CustomSelectTwo
              value={status}
              onChange={handleChange1}
              displayEmpty
            >
              {/* <MenuItem value={""}></MenuItem> */}
              {yearList.map((_y) => (
                <MenuItem key={_y} value={_y}>
                  {_y == new Date().getFullYear() ? "This year" : _y}
                  {/* {_y} */}
                </MenuItem>
              ))}
            </CustomSelectTwo>
          </Box>

          <Grid container spacing={2.88}>
            <Grid item xs={6}>
              <Box
                className={`${styles1.analyticsBreakdownHeader} ${styles.analyticsPageBreakdownHeader}`}
              >
                <Button>January - June</Button>
              </Box>
              <Box
                className={`${styles1.analyticsBreakdownTable} ${styles.analyticsPageBreakdownTable}`}
              >
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={styles.month}>Month</TableCell>
                        <TableCell className={styles.amount}>
                          Total Amount
                        </TableCell>
                        <TableCell className={styles.download}>
                          Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listdata &&
                        listdata.length > 0 &&
                        listdata.slice(0, midpoint).map((row) => (
                          <TableRow
                            key={row.month}
                            className={`${
                              row.count == 0 ? "disableExpenses" : ""
                            }`}
                          >
                            <TableCell>{row.month}</TableCell>
                            <TableCell>
                              {row.count == 0 ? "-" : row.count}
                            </TableCell>
                            <TableCell>
                              {/* <Button><img src={assest.downloadReportIcon} width={17} height={15} alt='' /></Button> */}
                              {row.count != 0 && (
                                <Button
                                  onClick={() =>
                                    expenseDetailsHandler(
                                      row.month_no,
                                      row.month
                                    )
                                  }
                                >
                                  <img
                                    src={assest.eyeIconBlack}
                                    width={15}
                                    height={11}
                                    alt=""
                                  />
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                className={`${styles1.analyticsBreakdownHeader} ${styles.analyticsPageBreakdownHeader}`}
              >
                <Button>July - December</Button>
              </Box>
              <Box
                className={`${styles1.analyticsBreakdownTable} ${styles.analyticsPageBreakdownTable}`}
              >
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={styles.month}>Month</TableCell>
                        <TableCell className={styles.amount}>
                          Total Amount
                        </TableCell>
                        <TableCell className={styles.download}>
                          Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listdata &&
                        listdata.length > 0 &&
                        listdata.slice(-midpoint).map((row) => (
                          <TableRow
                            key={row.month}
                            className={`${
                              row.count == 0 ? "disableExpenses" : ""
                            }`}
                          >
                            <TableCell>{row.month}</TableCell>
                            <TableCell>
                              {row.count == 0 ? "-" : row.count}
                            </TableCell>
                            <TableCell>
                              {/* <Button><img src={assest.downloadReportIcon} width={17} height={15} alt='' /></Button> */}
                              {row.count != 0 && (
                                <Button
                                  onClick={() =>
                                    expenseDetailsHandler(
                                      row.month_no,
                                      row.month
                                    )
                                  }
                                >
                                  <img
                                    src={assest.eyeIconBlack}
                                    width={15}
                                    height={11}
                                    alt=""
                                  />
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <ApiLoader loading={isLoading} />
      )}
    </Box>
  );
};

export default AnalyticPageBreakdownTable;
